var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1921_2143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_1921_2143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3362 13.2255C18.0135 13.2255 18.5625 12.6766 18.5625 11.9995C18.5625 11.3223 18.0135 10.7734 17.3362 10.7734L13.4859 10.7734C12.8087 10.7734 12.2597 11.3223 12.2597 11.9995C12.2597 12.6766 12.8087 13.2255 13.4859 13.2255L17.3362 13.2255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6298 14.2497C15.4214 14.1638 15.1913 14.1455 14.972 14.1975C14.7528 14.2495 14.5553 14.3691 14.4077 14.5394C13.89 15.1385 13.2016 15.565 12.4347 15.7618C11.6677 15.9587 10.859 15.9164 10.1167 15.6406C9.37452 15.3649 8.73432 14.8688 8.28194 14.219C7.82956 13.5692 7.58662 12.7966 7.58567 12.0048C7.58472 11.213 7.82581 10.4399 8.27663 9.78895C8.72745 9.13803 9.36646 8.64047 10.108 8.36294C10.8496 8.08541 11.6582 8.04118 12.4256 8.23616C13.193 8.43115 13.8825 8.85605 14.4016 9.4539C14.5497 9.62562 14.7479 9.74654 14.9683 9.79961C15.1887 9.85267 15.4203 9.83521 15.6302 9.74968C16.3066 9.47172 16.5209 8.61062 16.0427 8.05703C15.2385 7.1249 14.1684 6.46102 12.9761 6.15446C11.7837 5.8479 10.5262 5.91332 9.37207 6.34195C8.21798 6.77058 7.22257 7.54191 6.5194 8.55246C5.81623 9.56302 5.43894 10.7644 5.43813 11.9956C5.43733 13.2267 5.81305 14.4286 6.5149 15.4401C7.21675 16.4516 8.21115 17.2242 9.36468 17.6543C10.5182 18.0845 11.7757 18.1515 12.9685 17.8465C14.1612 17.5415 15.2321 16.879 16.0376 15.948C16.1485 15.8185 16.2271 15.6647 16.267 15.499C16.307 15.3333 16.307 15.1604 16.2672 14.9947C16.2274 14.829 16.1489 14.675 16.0381 14.5455C15.9273 14.416 15.7874 14.3146 15.6298 14.2497Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1921_2143",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 23.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0749"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1921_2143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.232fe5c486dd501b7244b4d62c8fafb9.svg";
export { ForwardRef as ReactComponent };